module.exports = "<div class=\"row no-margin\">\n\n    <cat-panel title=\"Units\">\n      <cat-panel-linked-list\n        [items]=\"linkedUnits\"></cat-panel-linked-list>\n    </cat-panel>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/project-details/components/landing-pages/project-units-landing/project-units-landing.component.html
// module id = ../../../../../src/app/modules/project-details/components/landing-pages/project-units-landing/project-units-landing.component.html
// module chunks = main